import { useCallback } from "react";

import { HttpHeaderNames } from "@touchtech/web-api-client";
import { usePromise } from "@touchtech/web-hooks";

import { api, createCheckoutOrderConfirmUrl } from "@is/services";
import { CheckoutDetails } from "@is/types";

type ExtendedError = Error & { body: CheckoutDetails };

type Params = {
  sessionId: string;
  tenantId: string;
  checkoutConfigurationId?: string;
};

type State = {
  isPending: boolean;
  error: ExtendedError | null;
  data: CheckoutDetails | null;
};

async function handleCheckoutOrderConfirm(params: Params) {
  const url = createCheckoutOrderConfirmUrl(params.sessionId);
  const headers = new Headers({
    [HttpHeaderNames.TENANT_ID]: params.tenantId,
    "Content-type": "application/json",
  });

  const data = (await api.post(
    url,
    {
      ...(params?.checkoutConfigurationId
        ? { id: params.checkoutConfigurationId }
        : {}),
    },
    headers,
    false
  )) as CheckoutDetails;

  return data;
}

export const useCheckoutOrderConfirm = (): [
  State,
  (params: Params) => Promise<CheckoutDetails>
] => {
  const [{ isPending, error, data }, dispatch] = usePromise<CheckoutDetails>();

  const checkoutOrderConfirm = useCallback(
    (params: Params) => dispatch(handleCheckoutOrderConfirm(params)),
    [dispatch]
  );

  return [
    { isPending, error: error as ExtendedError, data },
    checkoutOrderConfirm,
  ];
};
